module.exports = __webpack_public_path__ + "static/media/agenda2021.c278ea54.png";